export default (state = {}, action) => {
  switch (action.type) {
    case 'ADD_ID_MODULO':
      return { ...state, idModulo: action.idModulo };
    case 'ADD_USER_GROUP_ID':
      return { ...state, idUser: action.idUser };
    case 'ADD_GROUP_ID':
      return { ...state, idGroup: action.idGroup };
    case 'ADD_COMPANY_ID':
      return { ...state, idPessoaEmpresa: action.idPessoaEmpresa };
    case 'ADD_MENU_ID':
      return { ...state, idMenu: action.idMenu };
    default:
      return state;
  }
};
